export default{
  "assign_delivery": "Assign Delivery",
  "estimated_delivery_time": "Estimated Delivery Time",
  "select_saved_driver": "-- Select Saved Delivery Boy --",
  "delivery_type": "Delivery Type",
  "own_delivery": "Own Delivery",
  "partner": "Partner",
  "driver_name": "Driver Name",
  "driver_mobile": "Driver Mobile",
  "vehicle_type": "Vehicle Type (Bike/Van/Truck)",
  "vehicle_number": "Vehicle Number (Optional)",
  "partner_name": "Partner Name",
  "confirm_delivery": "Confirm Delivery",
  "assigning": "Assigning..."
}